
const SirTrevor = require('sir-trevor');


SirTrevor.Blocks.Code = require('./blocks/code')
SirTrevor.Blocks.File = require('./blocks/file')
SirTrevor.Blocks.Html = require('./blocks/html')
SirTrevor.Blocks.Image = require('./blocks/image').default
SirTrevor.Blocks.Markdown = require('./blocks/markdown')
SirTrevor.Blocks.Table = require('./blocks/table').default
SirTrevor.Blocks.Video = require('./blocks/video').default
SirTrevor.Blocks.Iframe = require('./blocks/iframe').default
SirTrevor.Blocks.Text = require('./blocks/text').default
SirTrevor.Blocks.List = require('./blocks/list').default

const headers = {};
const csrfMetaTag = document.querySelector('meta[name=csrf-token]');

if (csrfMetaTag) {
  headers['X-CSRF-Token'] = csrfMetaTag.getAttribute('content');
}

SirTrevor.setDefaults({
  uploadUrl: "/images",
  iconUrl: document.body.getAttribute('data-st-icons-url'),
  ajaxOptions: {
    headers: headers,
    credentials: 'same-origin'
  },
  defaultType: "Text",
  formatBar: {
    commands: [
      {
        name: "Bold",
        title: "bold",
        iconName: "fmt-bold",
        cmd: "bold",
        keyCode: 66,
        text : "B"
      },
      {
        name: "Italic",
        title: "italic",
        iconName: "fmt-italic",
        cmd: "italic",
        keyCode: 73,
        text : "i"
      },
      {
        name: "Link",
        title: "link",
        iconName: "fmt-link",
        cmd: "linkPrompt",
        text : "link",
      },
      {
        name: "Unlink",
        title: "unlink",
        iconName: "fmt-unlink",
        cmd: "unlink",
        text : "link",
      }
    ]
  }
})

SirTrevor.Blocks.List.prototype.focus = function() {
  if (this.editorIds.length) {
    this.getTextEditor(this.editorIds[0]).el.focus()
  }
}

SirTrevor.Blocks.Video.prototype.drop_options = {
  html: [
          '<div class="st-block__dropzone">',
          '<svg role="img" class="st-icon">',
          '<use xlink:href="<%= config.defaults.iconUrl %>#<%= _.result(block, "icon_name") %>"/>',
          '</svg>',
          '<p>Embed <span>Video</span></p>',
          '</div>'
        ].join('\n'),
  re_render_on_reorder: false
};

window.SirTrevor = SirTrevor;
SirTrevor.Locales.en.general.paste = 'Paste URL here';

export default SirTrevor
